<template>
  <v-dialog
    v-model="visible"
    persistent
    width="350"
  >
    <v-card>
      <v-card-text>
        <v-form>
          <Reference
            v-model="value"
            :label="`Категория`"
            :outline="false"
            :disable-add="true"
            resource="product-categories"
          />

          <div class="space" />

          <v-btn
            small
            color="primary"
            @click="update"
          >
            Применить
          </v-btn>
          <v-btn
            small
            @click="closeDialog"
          >
            Отмена
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Reference from "../../../components/reference/Reference.vue";

export default {
  components: {
    Reference,
  },
  props: [
    "visible",
  ],
  data() {
    return {
      value: null,
    };
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    update() {
      const categoryId = this.value ? this.value.id : null;
      this.$emit("onUpdate", categoryId);
      this.closeDialog();
    },
    closeDialog() {
      this.value = null;
      this.$emit("onClose");
    },
  },
};
</script>

<style>
.space {
  display: block;
  height: 1.5rem;
}
</style>
